// extracted by mini-css-extract-plugin
export default {"title":"SignIn_title__lsZJS","description":"SignIn_description__yRWj6","form":"SignIn_form__fGPvR","requirements":"SignIn_requirements__jEnXa","row":"SignIn_row__wbfXx"};